/**
 * Что юрлицу обязательно заполнить — и что не обязательно.
 *
 * Правило одно и простое: реквизиты нужны тому, кому выставляют СЧЁТ.
 *
 *   - «По договору» — счёт выставляется, значит нужны номер договора, ИНН,
 *     банк и расчётный счёт: всё это печатается в документе;
 *   - «Наличные» — счёта нет вовсе. Клиника платит на месте, юрлицо заведено
 *     только затем, чтобы заказу было к чему привязаться. Требовать от него
 *     договор — требовать заполнить поля, которые никуда не попадут.
 *
 * Правило ЗДЕСЬ, а не в каждом экране: иначе список «Договоры» ругается на
 * наличную клинику, карточка молчит, а счёт печатается с пустыми полями —
 * три места с тремя разными представлениями об одном и том же.
 *
 * Важное, что это правило НЕ решает: способ оплаты юрлица — значение по
 * УМОЛЧАНИЮ для заказа, а не запрет. Врач из клиники «по договору» вправе
 * заплатить за конкретную работу наличными, и наоборот; заказ это позволяет,
 * а проверка ниже смотрит только на юрлицо.
 */
/** Нужен ли юрлицу договор. Наличным — нет. */
export function needsContract(pay) {
    return pay === 'По договору';
}
/**
 * Чего не хватает для выставления счёта.
 *
 * Возвращает подписи полей в том виде, в каком они названы в карточке, —
 * сообщение «не заполнены ИНН, расчётный счёт» должно вести к конкретным
 * полям, а не к общему «проверьте реквизиты».
 *
 * Почта в список НЕ входит: без неё счёт печатается и отдаётся из рук в руки,
 * это не препятствие, а неудобство.
 */
export function missingInvoiceRequisites(legal) {
    if (!needsContract(legal.pay))
        return [];
    const missing = [];
    if (!legal.contractNo.trim())
        missing.push('договор');
    if (!legal.inn.trim())
        missing.push('ИНН');
    if (!legal.bank.trim())
        missing.push('банк');
    if (!legal.rs.trim())
        missing.push('расчётный счёт');
    return missing;
}
/**
 * Нужна ли юрлицу почта.
 *
 * По той же причине, что и договор: почта заведена для отправки счетов,
 * а наличной клинике счёт не выставляют.
 */
export function needsEmail(pay) {
    return pay === 'По договору';
}
//# sourceMappingURL=legal-requisites.js.map